import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LoadableMultiComponents from 'common/components/Loadable/LoadableMultiComponents';

export default class LoadableAddToHubModal extends Component {
    static propTypes = {
        open: PropTypes.bool,
        eventsToAddToHub: PropTypes.array,
        hubsToDisable: PropTypes.array,
        onRequestClose: PropTypes.func,
        onSuccess: PropTypes.func,
        onModalOpen: PropTypes.func,
    };

    static defaultProps = {
        open: false,
        eventsToAddToHub: [],
        hubsToDisable: [],
        onRequestClose: () => {},
        onSuccess: () => {},
        onModalOpen: () => {},
    };

    openAddToHubModal = () => {};

    closeAddToHubModal = () => {};

    componentDidMount() {
        if (this.props.open) {
            this.openAddToHubModal(this.props.eventsToAddToHub, this.props.hubsToDisable);
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.open !== this.props.open) {
            if (nextProps.open) {
                this.openAddToHubModal(nextProps.eventsToAddToHub, this.props.hubsToDisable);
            }
        }
    }

    handleCloseModal = () => {
        this.props.onRequestClose();
        this.closeAddToHubModal();
    };

    render() {
        const { open, eventsToAddToHub, hubsToDisable, onSuccess, onModalOpen } = this.props;

        return open ? (
            <LoadableMultiComponents
                importComponents={{
                    compoundInterface: () =>
                        import('../../interface' /* webpackChunkName: "AddToHubModalInterface" */) // eslint-disable-line max-len
                            .then((module) => {
                                const createInterface = module.default;
                                const namespace = module.reducerNamespace;

                                if (window.SPLASH && window.SPLASH.registerCompound) {
                                    const compoundInterface = window.SPLASH.registerCompound(
                                        createInterface,
                                        namespace,
                                    );

                                    this.openAddToHubModal = compoundInterface.open;
                                    this.closeAddToHubModal = compoundInterface.close;

                                    compoundInterface.open(eventsToAddToHub, hubsToDisable);
                                } else {
                                    throw new Error('No `registerCompound` registered in SPLASH');
                                }
                            }),
                    container: () =>
                        import('../../containers/AddToHubModal' /* webpackChunkName: "AddToHubModalContainer" */), // eslint-disable-line max-len
                }}
            >
                {(loaded) => {
                    const AddToHubModal = loaded.container.default;
                    return (
                        <AddToHubModal
                            onRequestClose={this.handleCloseModal}
                            eventsToAddToHub={eventsToAddToHub}
                            hubsToDisable={hubsToDisable}
                            onSuccess={onSuccess}
                            onModalOpen={onModalOpen}
                        />
                    );
                }}
            </LoadableMultiComponents>
        ) : null;
    }
}
